import { ApolloLink, split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { Kind, OperationTypeNode } from 'graphql';

export const splitLink = (wsLink: ApolloLink, restLink: ApolloLink) =>
  split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return definition.kind === Kind.OPERATION_DEFINITION && definition.operation === OperationTypeNode.SUBSCRIPTION;
    },
    // if above is true, WS
    wsLink,
    // REST otherwise
    restLink
  );
